import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'
import CareerPositions from '../components/CareerPositions'

const Careers = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="relative bg-gray-900">
            <div className="absolute inset-0">
              <img
                className="w-full h-full object-cover opacity-30"
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
                alt="Careers"
              />
            </div>
            <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
              <div className="text-center mb-10">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                  <span className="block">Grow Your Career With Us</span>
                </h1>
                <p className="mt-4 max-w-3xl text-xl text-gray-100 mx-auto">
                  Join our team of digital marketing innovators and help shape the future of businesses.
                </p>
              </div>
            </div>
          </div>
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            {/* Why Join Us Section */}
            <div className="bg-primary-50 rounded-xl p-8 mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                Why Work at TheMarketingFeeds.com?
              </h2>
              <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
                <div className="text-center">
                  <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Impactful Work</h3>
                  <p className="text-gray-600">
                    Work with diverse clients and see the direct impact of your contributions on their business growth.
                  </p>
                </div>
                <div className="text-center">
                  <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Continuous Learning</h3>
                  <p className="text-gray-600">
                    Regular training, conference budgets, and mentorship programs to keep you at the industry forefront.
                  </p>
                </div>
                <div className="text-center">
                  <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white mb-4">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Great Culture</h3>
                  <p className="text-gray-600">
                    Collaborative environment with flexible work options and regular team events.
                  </p>
                </div>
              </div>
            </div>

            {/* Current Openings */}
            <div className="mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                Current Open Positions
              </h2>
              {/* <CareerPositions /> */}
              <p className="text-gray-600 text-center bg-gray-50 p-6 rounded-sm shadow text-xl">
                No current openings at the moment. Please check back later or submit your resume for future opportunities.
              </p>
            </div>

            {/* Benefits Section */}
            <div className="mb-16">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 pb-2 border-b border-gray-200">
                Our Benefits
              </h2>
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white p-6 rounded-lg shadow border border-gray-100">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Health & Wellness</h3>
                  <p className="text-gray-600">Comprehensive medical, dental, and vision insurance</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow border border-gray-100">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Flexible Work</h3>
                  <p className="text-gray-600">Remote options and flexible hours for most positions</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow border border-gray-100">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Learning Budget</h3>
                  <p className="text-gray-600">$2,000 annual budget for professional development</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow border border-gray-100">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Generous PTO</h3>
                  <p className="text-gray-600">20 days PTO plus holidays and flexible sick days</p>
                </div>
              </div>
            </div>

            {/* Culture Section */}
            <div className="bg-primary-50 rounded-xl p-8">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                <div className="mb-8 lg:mb-0">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Culture</h2>
                  <p className="text-gray-600 mb-4">
                    At TheMarketingFeeds.com, we believe our people are our greatest asset. We foster an environment where creativity meets data-driven strategy, and where every team member can grow both personally and professionally.
                  </p>
                  <p className="text-gray-600 mb-4">
                    We value transparency, collaboration, and continuous learning. Our team comes from diverse backgrounds but shares a common passion for delivering exceptional results for our clients.
                  </p>
                  <Link
                    to="/about"
                    className="inline-flex items-center text-primary-700 font-medium"
                  >
                    Learn more about our company
                    <svg className="ml-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
                <div>
                  <img
                    className="w-full rounded-lg shadow-lg"
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                    alt="TheMarketingFeeds.com team working together"
                  />
                </div>
              </div>
            </div>

            {/* Application CTA */}
            <div className="mt-16 text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Don't See the Perfect Role?
              </h2>
              <p className="text-xl text-gray-600 mb-6 max-w-2xl mx-auto">
                We're always looking for talented people. Send us your resume and we'll contact you when a matching position opens up.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
              >
                Submit Your Resume
                <svg className="ml-3 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Careers